import http from 'hub-http/clients/apiClient';
const BASE_PATH = 'crm-search/report';
export const fetchReport = ({
  query
}) => http.post(BASE_PATH, {
  data: query
});